import React from 'react';
import './_conteudo.css';

export default ({children})=>{
    return(
        <div className="conteudo">
            {children}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/conteudo/Conteudo.js